import React from 'react';

interface HeartRefreshIconProps {
  className?: string;
}

function HeartRefreshIcon({ className }: HeartRefreshIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      className={className}
    >
      <g id="replay">
        <mask
          id="mask0_13282_37011"
          width="25"
          height="25"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
        >
          <path id="Bounding box" fill="#D9D9D9" d="M0 0h24v24H0z" transform="matrix(-1 0 0 1 24.047 .382)"></path>
        </mask>
        <g mask="url(#mask0_13282_37011)">
          <g id="Icon" fill="currentColor">
            <path d="M6.222 19.79a8.7 8.7 0 0 0 3.1 1.798q1.697.554 3.41.452a9.2 9.2 0 0 0 3.33-.853 8.7 8.7 0 0 0 2.865-2.154.97.97 0 0 0 .258-.724.97.97 0 0 0-.342-.688.97.97 0 0 0-.724-.258q-.405.024-.688.342-1.941 2.188-4.818 2.359-2.875.171-5.064-1.77-2.187-1.942-2.359-4.818-.171-2.877 1.77-5.064t4.819-2.36q2.876-.17 5.064 1.771l.112.1-1.2.071a.92.92 0 0 0-.68.333q-.255.307-.25.714.027.424.326.707a.93.93 0 0 0 .724.258l3.635-.217a.96.96 0 0 0 .689-.324q.265-.3.24-.723l-.216-3.635a.93.93 0 0 0-.342-.688 1.02 1.02 0 0 0-.74-.24q-.405.043-.68.334a.92.92 0 0 0-.25.714l.072 1.2-.113-.1a8.7 8.7 0 0 0-3.1-1.798 9.2 9.2 0 0 0-3.409-.453 9.2 9.2 0 0 0-3.331.854 8.7 8.7 0 0 0-2.865 2.154 8.7 8.7 0 0 0-1.799 3.1 9.2 9.2 0 0 0-.452 3.41 9.2 9.2 0 0 0 .854 3.331 8.7 8.7 0 0 0 2.154 2.864"></path>
            <path d="M12.2 17.133a.9.9 0 0 1-.285-.05.7.7 0 0 1-.255-.158l-.69-.624a27 27 0 0 1-1.915-1.906Q8.2 13.45 8.2 12.311q0-.93.63-1.554t1.57-.624q.53 0 1 .223.47.222.8.608a2.38 2.38 0 0 1 1.8-.831q.94 0 1.57.624.63.623.63 1.554 0 1.14-.85 2.09t-1.93 1.91l-.68.614a.7.7 0 0 1-.255.158.9.9 0 0 1-.285.05"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HeartRefreshIcon;
